/*
 *
 * Patient Search Constants
 *
 */

export const PATIENT_SEARCH_REQUEST_SENT = 'src/PatientSearch/PATIENT_SEARCH_REQUEST_SENT';
export const PATIENT_SEARCH_REQUEST_SUCCEED = 'src/PatientSearch/PATIENT_SEARCH_REQUEST_SUCCEED';
export const PATIENT_SEARCH_REQUEST_FAILED = 'src/PatientSearch/PATIENT_SEARCH_REQUEST_FAILED';
